import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './AuthContext';
import { AdminAuthProvider } from './AdminAuthContext';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId="987740287283-ba8246b7otfcnb9eqk3obe5u675i8vfe.apps.googleusercontent.com">
    <React.StrictMode>
      <AdminAuthProvider>
        <AuthProvider>
          <HashRouter>
            <App />
          </HashRouter>
        </AuthProvider>
      </AdminAuthProvider>
    </React.StrictMode>
  </GoogleOAuthProvider>
);

reportWebVitals();
